export default __webpack_public_path__ + "static/media/get-satisfaction.a7a9e52d.svg";